import './App.css';
import React from "react";
import Weather from "./Weather";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="New York" />
      <footer>
        <a href="https://github.com/edc98/final-weather-app-react" target="_blank" rel="noopener noreferrer">Open-source Code</a> on Github by <a href="https://unruffled-aryabhata-993a24.netlify.app/" target="_blank" rel="noopener noreferrer">Emma Duensing</a>
      </footer>
      </div>
    </div>
  );
}
